// extracted by mini-css-extract-plugin
module.exports = {"formInputs":"contact_formInputs__CXMK3","errorColor":"contact_errorColor__UMsCd"};